module.exports = __webpack_public_path__ + "img/sym1.59b47c25.png";